<template>
  <advanced-table
    :headers="headers"
    :filters="filters"
    :expand="expand"
    :sortBy="'date'"
    :descending="true"
    :resource="resource"
    :optionLists="optionLists"
  />
</template>

<script>
import AdvancedTable from "@/components/AdvancedTable.vue";
import { format } from "date-fns";

export default {
  data() {
    return {
      actions: {
        CREATE: { name: "יצירה", color: "green" },
        UPDATE: { name: "עריכה", color: "blue" },
        REMOVE: { name: "מחיקה", color: "red" }
      },
      headers: [
        {
          text: "שם",
          value: "user",
          align: "right",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            let user = this.entityById(
              "users",
              data[key] && data[key]._id ? data[key]._id : data[key]
            );
            return user ? user.name : "ללא";
          }
        },
        {
          text: "זמן",
          value: "date",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            return format(data[key], "DD-MM-YYYY HH:mm");
          }
        },
        {
          text: "פעולה",
          value: "action",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            let action = this.actions[data[key]];
            return action ? action.name : "לא ידוע";
          }
        },
        {
          text: "סוג משאב",
          value: "resourceType",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            return data[key];
          }
        }
      ],
      expand: {
        text: "מידע נוסף",
        value: "payload",
        align: "left",
        pre: true,
        displayFunc: (data, key) => {
          return JSON.stringify(data[key], null, 4);
        }
      },
      filters: [
        {
          type: "COMBOBOX",
          label: "שם",
          model: "users",
          items: "users",
          itemText: "name",
          itemValue: "_id",
          active: true
        },
        {
          type: "DATE",
          label: "תאריך אחרי",
          model: "dateAfter",
          active: true
        },
        {
          type: "DATE",
          label: "תאריך לפני",
          model: "dateBefore",
          active: true
        }
      ]
    };
  },
  computed: {
    roles() {
      return this.$store.getters["entityList"]("activityLogs");
    },
    users() {
      return Object.values(this.$store.state.entities.users);
    },
    resource() {
      return this.$store.state.resources["activityLog"];
    },
    optionLists() {
      return {
        users: this.users
      };
    }
  },
  methods: {
    entityById(entityType, id) {
      return this.$store.getters["entity"](entityType, id);
    }
  },
  watch: {},
  components: {
    AdvancedTable
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/reports/ActivityLogs.vue